interface GridModeToggleProps {
  showGridMode: boolean;
  onToggle: () => void;
}

/** Grid Mode toggle button - shows/hides tile grid overlay. */
export default function GridModeToggle({ showGridMode, onToggle }: GridModeToggleProps) {
  return (
    <div
      onClick={onToggle}
      style={{
        position: 'absolute',
        top: 66,
        right: 16,
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        padding: '6px 24px',
        borderRadius: '50px',
        background: 'rgba(219, 219, 219, 0.3)',
        boxShadow: 'inset 4px 3px 5.9px 0px rgba(0, 0, 0, 0.12)',
        cursor: 'pointer',
        pointerEvents: 'auto',
      }}
    >
      <img
        src="/ui/icons/grid-mode-icon.png"
        alt="Grid"
        style={{
          width: '28px',
          height: '28px',
          objectFit: 'contain',
          pointerEvents: 'none',
        }}
      />
      <div
        style={{
          position: 'relative',
          width: '39px',
          height: '24px',
          borderRadius: '100px',
          background: showGridMode ? '#6750A4' : 'rgba(219, 219, 219, 0.5)',
          padding: '1.5px 3px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: showGridMode ? 'flex-end' : 'flex-start',
          transition: 'all 0.2s ease',
        }}
      >
        <div
          style={{
            width: '21px',
            height: '21px',
            borderRadius: '24px',
            background: '#FFFFFF',
            boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.3)',
            transition: 'all 0.2s ease',
          }}
        />
      </div>
    </div>
  );
}
